import { useQuery } from "@tanstack/react-query";
import { Badge } from "antd";
import type { ReactNode } from "react";

import { api } from "../api";

type Badges = {
  support: number | null;
  messageReports: number | null;
  questionReports: number | null;
  profileChanges: number | null;
};

/** How often the menu's red counts refresh. */
const REFRESH_MS = 15_000;

/** Red counts on menu items (product decision 2026-10-09): unread support, open reports. */
export function useBadges() {
  return useQuery({
    queryKey: ["office", "badges"],
    queryFn: () => api<Badges>("/api/office/badges"),
    refetchInterval: REFRESH_MS,
  });
}

/**
 * A menu icon with the item's red count; nothing extra when there is none to show. The menu
 * gives its icon a class that spaces the label (`className`); it must reach the outer element.
 */
export function MenuBadge({
  count,
  children,
  className,
}: {
  count: keyof Badges;
  children: ReactNode;
  className?: string;
}) {
  const { data } = useBadges();
  const value = data?.[count] ?? 0;
  return (
    <Badge
      className={className}
      count={value}
      size="small"
      offset={[2, -4]}
      title={`${value} bekleyen`}
    >
      {children}
    </Badge>
  );
}
